const SYSTEM = {
    MANAGE_RENTAL: "SYSTEM__MANAGE-RENTAL",
    MEMBERSHIP: "SYSTEM__MEMBERSHIP",
    MEMBERSHIP__APPROVE: "SYSTEM__MEMBERSHIP__MEMBERSHIP-APPROVE",
    TRANSLATE: "SYSTEM__TRANSLATE",
    TRANSLATE__ADD: "SYSTEM__TRANSLATE__TRANSLATE-ADD",
    TRANSLATE__UPDATE: "SYSTEM__TRANSLATE__TRANSLATE-UPDATE",
    TRANSLATE__DELETE: "SYSTEM__TRANSLATE__TRANSLATE-DELETE",
    TRANSLATE__SELECT_LOCALE: "SYSTEM__TRANSLATE__TRANSLATE-SELECT-LOCALE",
    BOARD: "SYSTEM__BOARD",
    BOARD_NOTICE: "SYSTEM__BOARD__BOARD-NOTICE",
    BOARD_FAQ: "SYSTEM__BOARD__BOARD-FAQ",
    CONFIG_MANAGE: "SYSTEM__CONFIG-MANAGE",
    CONFIG_RENTALCOMPANY: "SYSTEM__CONFIG-MANAGE__CONFIG-RENTALCOMPANY",
    CONFIG_USER: "SYSTEM__CONFIG-MANAGE__CONFIG-USER",
    SYSTEM_CODE: "SYSTEM__SYSTEM-CODE",
    MANUAL: "SYSTEM__MANUAL",
    MANUAL_MANAGE: "SYSTEM__MANUAL__MANUAL-MANAGE",
    CHARGE_EMAIL: "SYSTEM__CHARGE-EMAIL",
    MONITORING: "SYSTEM__MONITORING",
    MONITORING_DEPLOY: "SYSTEM__MONITORING__MONITORING-DEPLOY",
    MONITORING_VERSION_MANAGE: "SYSTEM__MONITORING__MONITORING-VERSION-MANAGE",
    MONITORING_CYCLE_CONFIG: "SYSTEM__MONITORING__MONITORING-CYCLE-CONFIG",
    MONITORING_CYCLE_MANAGE: "SYSTEM__MONITORING__MONITORING-CYCLE-MANAGE",
    MONITORING_PRINTER_SEARCH_RULE: "SYSTEM__MONITORING__MONITORING-PRINTER-SEARCH-RULE",
    MONITORING_PRINTER_SERIES: "SYSTEM__MONITORING__MONITORING-PRINTER-SERIES",
    MONITORING_SUPPLY: "SYSTEM__MONITORING__MONITORING-SUPPLY",
    MONITORING_SYSTEM_LOG_VIEWER: "SYSTEM__MONITORING__SYSTEM-LOG-VIEWER",
    MONITORING_PRINTER_SUPPLIES: "SYSTEM__MONITORING__MONITORING-PRINTER-SUPPLIES",
    BATCH_MONITORING: "SYSTEM__BATCH__MONITORING",
    SYSTEM_USER: "SYSTEM__SYSTEM-USER",
    SYSTEM_USER_LIST: "SYSTEM__SYSTEM-USER__SYSTEM-USER-LIST",
    SYSTEM_USER_REGISTER: "SYSTEM__SYSTEM-USER__SYSTEM-USER-REGISTER",
    SYSTEM_PERMISSION: "SYSTEM__SYSTEM-PERMISSION",
    SYSTEM_PERMISSION_MANAGE: "SYSTEM__SYSTEM-PERMISSION__SYSTEM-PERMISSION-MANAGE",
    SYSTEM_PERMISSION_GROUP_MANAGE: "SYSTEM__SYSTEM-PERMISSION__SYSTEM-PERMISSION-GROUP-MANAGE",
};

const RENTAL = {
    RENTAL_ADMIN: "RENTAL-ADMIN",
    RENTAL_WORKER: "RENTAL-WORKER",
    MENU_NAV: "MENU__NAV",
    MENU_NAV_HOME: "MENU__NAV__HOME",
    MENU_NAV_ACCOUNT: "MENU__NAV__ACCOUNT",
    MENU_NAV_ACCOUNT_ACCOUNT_LOG_EDIT: "MENU__NAV__ACCOUNT__ACCOUNT-LOG__ACCOUNT-LOG-EDIT",
    MENU_NAV_ACCOUNT_ACCOUNT_LOG_REGISTER: "MENU__NAV__ACCOUNT__ACCOUNT-LOG__ACCOUNT-LOG-REGISTER",
    MENU_NAV_PRINTER: "MENU__NAV__PRINTER",
    MENU_NAV_DEVICE: "MENU__NAV__DEVICE",
    MENU_NAV_WORK: "MENU__NAV__WORK",
    MENU_NAV_WORK_EACH_WORKER: "MENU__NAV__WORK__EACH-WORKER",
    MENU_NAV_SALES: "MENU__NAV__SALES",
    MENU_NAV_MANAGER: "MENU__NAV__MANAGER",
    EXPOSE: "EXPOSE",
    EXPOSE_SUMMARY: "EXPOSE__SUMMARY",
    EXPOSE_SUMMARY_SALES: "EXPOSE__SUMMARY__SALES-SUMMARY",
}

const Permissions = {
    SYSTEM,
    RENTAL,
}

export default Permissions
